module.exports = __webpack_public_path__ + "img/login-bg-976614b0995e792712d1ebc80be191bf.svg";